/**
 * Singleton to manage conceptual "layers"
 */

export default class LayersManager {
  _layersById = {};
  _layerIds = [];

  loadLayers(layers) {
    this.clear();

    const allMediaItems = [];
    layers.forEach((layer, index) => {
      const zIndex = index;
      const layerItemIds = layer.items.map((item) => item.id);
      const newLayer = { id: layer.id, itemIds: layerItemIds, zIndex };

      this._layersById[layer.id] = newLayer;
      this._layerIds.push(layer.id);
      allMediaItems.push(
        ...layer.items.map((item) => ({ ...item, zIndex, layerId: layer.id }))
      );
    });

    return allMediaItems;
  }

  clear() {
    this._layersById = {};
    this._layerIds = [];
  }

  getLayers() {
    return this._layerIds.map((layerId) => this_._layersById[layerId]);
  }
}
